export const searchActionsEnum = {
  searchBar: 'searchBar',
  quickMenu: 'quickMenu',
  filter: 'filter',
  scrolling: 'scrolling',
  sortBy: 'sortBy',
  pagination: 'pagination',
  init: 'init',
  history: 'history',
  colorRange: 'colorRange',
  initPrevResults: 'initPrevResults',
  taxonomy: 'taxonomy',
  reset: 'reset',
  customEvent: 'customEvent',
  resetFilters: 'resetFilters',
};

export const defaultMaxAmountOfProductsToAdd = 10;

export enum EngagementTargets {
  QV_OPEN = 'qv-open',
  CHANGE_PAGE = 'change-page',
  ATC = 'ATC',
}
